<template>
  <transition name="modal">
    <div class="modal-mask quote-duplicate-option-modal-mask" v-if="visible">
      <div class="modal-wrapper">
        <div class="options modal-container quote-duplicate-option-modal-container">
          <div class="modal-header">
            <i class="close icon" v-on:click="$emit('close')"></i>
            <h3>Duplicate Quote</h3>
          </div>

          <div class="ui divider"></div>

          <div class="modal-body scrolling content">
            <button
              type="button"
              class="ui fluid basic button quote-duplicate-choice"
              :disabled="variationDisabled"
              @click="$emit('variation')"
            >
              <i class="clone outline icon"></i>
              <strong>Add variation to this quote</strong>
            </button>
            <button
              type="button"
              class="ui fluid basic button quote-duplicate-choice"
              @click="$emit('new-quote')"
            >
              <i class="file outline icon"></i>
              <strong>Start as new quote</strong>
            </button>
            <p v-if="variationDisabled" class="quote-duplicate-hint">
              This quote already has the maximum of 3 options.
            </p>
          </div>

          <div class="modal-footer">
            <div class="ui basic button smardie-btn-secondary" @click="$emit('cancel')">Cancel</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'QuoteDuplicateOptionModal',
  emits: ['close', 'cancel', 'variation', 'new-quote'],
  props: {
    visible: { type: Boolean, default: true },
    optionCount: { type: Number, default: 1 }
  },
  computed: {
    variationDisabled () {
      return Number(this.optionCount) >= 3
    }
  },
  mounted: function () {
    this.portalToBody()
    this.$nextTick(this.portalToBody)
  },
  beforeUnmount: function () {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  methods: {
    portalToBody: function () {
      if (typeof document === 'undefined') return
      if (this.$el && this.$el.parentNode && this.$el.parentNode !== document.body) {
        document.body.appendChild(this.$el)
      }
    }
  }
}
</script>

<style scoped>
/* Above document preview (z-index 99); below signature (10050) */
.quote-duplicate-option-modal-mask.modal-mask {
  z-index: 200;
}
.quote-duplicate-option-modal-container.modal-container {
  max-width: 460px;
  width: 90vw;
}
.quote-duplicate-option-modal-container .modal-footer {
  text-align: left;
}
.quote-duplicate-choice {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  height: 44px !important;
  min-height: 44px !important;
  max-height: 44px !important;
  padding: 0 14px !important;
  margin: 0 0 10px 0 !important;
  text-align: left;
  line-height: 1.2 !important;
}
.quote-duplicate-choice:last-of-type {
  margin-bottom: 0 !important;
}
.quote-duplicate-choice i.icon {
  color: #4DA1FF;
  margin: 0 !important;
  font-size: 1.1em !important;
  width: auto !important;
  height: auto !important;
}
.quote-duplicate-choice strong {
  font-weight: 600;
}
.quote-duplicate-hint {
  color: #707070;
  font-size: 13px;
  margin: 10px 0 0;
}
</style>
